/**
 * One project-scope job at a time (migrate, reload). A reload that read the
 * projects before the migration saved one must not finish after it and call
 * that project gone. Used by ProjectScopeSync and the toolbar switcher.
 */
let chain = Promise.resolve();

export function enqueueScopeJob(job) {
  chain = chain.then(job, job);
  return chain;
}
